import { accessRole } from "../../../../helpers/access_role"

import React, { Fragment, useState, useRef, useEffect } from "react"
import classnames from "classnames"
import { Link } from "react-router-dom"
import apiResponse from "../../../../services/apiResponse"

import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input,
    Modal,ModalBody,ModalFooter, ModalHeader,
    FormGroup, FormFeedback, Label
} from "reactstrap"

import TableActiveComponent from './Components/TableActiveComponent'

import moment from 'moment';

const IndexView = (props) => {

    const [activeTab, setactiveTab] = useState("1")    
    const activeRef = useRef();
    const inactiveRef = useRef();
    
    const [nomorSurat, setNomorSurat] = useState("")
    const [nomorSuratValidation, setNomorSuratValidation] = useState(false)
    
    const [modal, setmodal] = useState(false)

    const reloadActiveRef = () => activeRef.current.setTokenAPI()
    const reloadInactiveRef = () => activeRef.current.setTokenAPI()

    function toggle(tab) {
        if (activeTab !== tab) {
            setactiveTab(tab)
        }
    }

    return (
        <Fragment>
            <Container fluid>
                <Row>
                    <Col xs="12">

                        <Card className="">
                            <CardBody>
                                <div className="float-end">
                                {/* {
                                    (accessRole('create')) ?
                                        <Link to="?create">
                                            <Button color="primary">Tambah Data</Button>
                                        </Link>
                                    : null
                                } */}
                                
                                </div>
                                <CardTitle>Periode CPNS</CardTitle>
                                {/* <CardSubtitle className="mb-3">
                                    Kelola Pencantuman Gelar
                                </CardSubtitle> */}
                                <hr />
                                <TableActiveComponent ref={activeRef} handleInactiveSuccess={reloadInactiveRef}/>
                            </CardBody>
                        </Card>
                        
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}

export default IndexView